module.exports = __webpack_public_path__ + "index4.58fec7b3.png";